import type { Dispatch } from '@avalara/types/actions';
import type { Result } from '@avalara/types/index';

import conf from '../../conf';
import fetch from '../fetch';

// Contract with PF-8565 (lead capture endpoint, not yet implemented): the server does lead
// capture + user provisioning + magic link generation in one call, then hands back where to
// redirect the browser. Nothing here decides the lead destination (MILES vs S3) or provisioning
// details - that's entirely server-side, per OQ-2/D24.
export type AviatorCrushSignupRequest = {
  firstName: string;
  lastName: string;
  email: string;
};

export type AviatorCrushSignupResponse = {
  redirectUrl: string;
};

export const submitAviatorCrushSignup = (
  dispatch: Dispatch,
  body: AviatorCrushSignupRequest,
): Promise<Result<AviatorCrushSignupResponse>> =>
  fetch(dispatch, { showLoadingWheel: false })<AviatorCrushSignupResponse>(`${conf.API_URL}/api/aviator-crush/signup`, {
    method: 'POST',
    body: JSON.stringify(body),
  });
